<template>
    <div :class="classes" :style="styles" @click="back">
        <slot>
            <div :class="innerClasses">
                <i class="ivu-icon ivu-icon-ios-arrow-up"></i>
            </div>
        </slot>
    </div>
</template>
<style>
    .ed-back-top {
        z-index: 10;
        position: fixed;
        cursor: pointer;
        display: none;
    }

    .ed-back-top.ed-back-top-show {
        display: block;
    }

    .ed-back-top-inner {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        -webkit-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }

    .ed-back-top-inner:hover {
        background-color: rgba(0, 0, 0, 0.7);
    }

    .ed-back-top i {
        color: #fff;
        font-size: 24px;
        padding: 8px 12px;
    }
</style>
<script>
    import { scrollTop, on, off } from "@/public/utils/tool";
    const prefixCls = "ed-back-top";

    export default {
        props: {
            height: {
                type: Number,
                default: 400,
            },
            bottom: {
                type: Number,
                default: 30,
            },
            right: {
                type: Number,
                default: 30,
            },
            duration: {
                type: Number,
                default: 1000,
            },
            elClass: {
                type: String,
                default: "",
            },
        },
        data() {
            return {
                backTop: false,
            };
        },
        mounted() {
            on(this.el, "scroll", this.handleScroll);
            on(window, "resize", this.handleScroll);
        },
        beforeDestroy() {
            off(this.el, "scroll", this.handleScroll);
            off(window, "resize", this.handleScroll);
        },
        computed: {
            classes() {
                return [
                    `${prefixCls}`,
                    {
                        [`${prefixCls}-show`]: this.backTop,
                    },
                ];
            },
            styles() {
                return {
                    bottom: `${this.bottom}px`,
                    right: `${this.right}px`,
                };
            },
            innerClasses() {
                return `${prefixCls}-inner`;
            },
            el() {
                let el;
                if (this.elClass) {
                    el = document.getElementsByClassName(this.elClass)[0];
                } else {
                    el = document.documentElement || document.body;
                }
                return el;
            },
        },
        methods: {
            handleScroll() {
                this.backTop = this.el.scrollTop >= this.height;
            },
            back() {
                const sTop = this.el.scrollTop;
                scrollTop(this.el, sTop, 0, this.duration);
                this.$emit("on-click");
            },
        },
    };
</script>
